/**
 * Extracts a readable title from a URL for file attachments (PDFs, markdown, etc.).
 */
export const extractReadableTitleFromUrl = (url: string): string => {
	let urlObj: URL;
	try {
		urlObj = new URL(url);
	} catch {
		return '';
	}

	const previewParam = urlObj.searchParams.get('preview');
	if (!previewParam) {
		return '';
	}

	const pathParts = previewParam.split('/');
	const filename = pathParts[pathParts.length - 1];
	if (!filename) {
		return '';
	}

	try {
		const decoded = decodeURIComponent(filename).replace(/\+/g, ' ').trim();
		return decoded && decoded.length > 0 ? decoded : '';
	} catch {
		return '';
	}
};
